module.exports = __webpack_public_path__ + "assets/img/a36b-pt.svg";